var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.lowThreshold") } },
    [
      _c("el-input-number", {
        staticClass: "hide-spin-button",
        staticStyle: { width: "100%" },
        attrs: { min: 1, max: _vm.optionModel.highThreshold },
        model: {
          value: _vm.optionModel.lowThreshold,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "lowThreshold", $$v)
          },
          expression: "optionModel.lowThreshold",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }